import API_PATH from "./env";
import { fetchToken } from "./Auth";

export default function apiFetch(path, options = {}) {
  const token = fetchToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${API_PATH}${path}`, { ...options, headers });
}
